import axios from "axios";
import XLSX from "xlsx";

// using sheetsjs
// https://docs.sheetjs.com/docs/

export default {
  methods: {
    async exportTemuanrekomendasiperlhaToExcel(val, opsi) {
      const rows = await this.loadDataReportTemuanrekomendasiperlha(val, opsi);

      /* generate worksheet and workbook */
      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Temuan Rekomendasi Per LHA"
      );

      /* create an XLSX file and try to save to Presidents.xlsx */
      XLSX.writeFile(workbook, "Temuan Rekomendasi Per LHA.xlsx", {
        compression: true,
      });
    },

    async loadDataReportTemuanrekomendasiperlha(val, opsi) {
      try {
        const response = await axios({
          method: "GET",
          baseURL: this.$apiAddress,
          url: val.endpoint,
          params: {
            token: localStorage.getItem("api_token"),
            fromDate: opsi.dateMulai.toLocaleDateString("fr-CA"),
            toDate: opsi.dateSelesai.toLocaleDateString("fr-CA"),
          },
        });

        if (response.status == 200) {
          const responseData = await response.data;
          //   console.log("--> Response DATA : ", responseData);
          return responseData;
        }
      } catch (error) {
        console.log(error.message);
      }
    },
  },
};
